module.exports = __webpack_public_path__ + "img/ep-Y.5a280ef5.jpg";